module.exports = __webpack_public_path__ + "static/media/IEARN-icon.c69913c1.png";